"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _renderProp = require("../utils/propTypes/renderProp");

var _Functions = require("../core/Functions");

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)([""]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var activeContextValue = {
  transitioning: true
};
var inactiveContextValue = {
  transitioning: false
};

var getContextValue = function getContextValue(transitioning) {
  return transitioning ? activeContextValue : inactiveContextValue;
};

var TwoWayTransition =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(TwoWayTransition, _React$Component);

  function TwoWayTransition(props) {
    var _this;

    (0, _classCallCheck2.default)(this, TwoWayTransition);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(TwoWayTransition).call(this, props));

    _this.stopTransition = function (forceHidden) {
      var _this$props = _this.props,
          onOpenComplete = _this$props.onOpenComplete,
          onCloseComplete = _this$props.onCloseComplete;
      var hidden = _this.state.hidden; // In the duration={0} scenario, state has not yet flushed, so we pass it explicitly.

      var computedHidden = forceHidden != null ? forceHidden : hidden;
      if (computedHidden) (0, _Functions.callIfPossible)(onCloseComplete);
      if (!_this._isMounted) return;
      if (!computedHidden) (0, _Functions.callIfPossible)(onOpenComplete);

      _this.setState({
        transitioning: false,
        transitionActive: false
      });

      if (computedHidden) {
        _this.cacheChildren(null);
      }
    };

    var children = props.children,
        transitionOnMount = props.transitionOnMount;
    _this.state = {
      cachedChildren: children,
      hidden: transitionOnMount ? (0, _renderProp.isRenderable)(children) : children == null,
      transitioning: false,
      transitionActive: false,
      opening: false,
      closing: false
    };
    _this._t = 0;
    return _this;
  }

  (0, _createClass2.default)(TwoWayTransition, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this._isMounted = true;
      var _this$props2 = this.props,
          children = _this$props2.children,
          duration = _this$props2.duration,
          onOpenStart = _this$props2.onOpenStart,
          onOpenComplete = _this$props2.onOpenComplete,
          transitionOnMount = _this$props2.transitionOnMount;

      if (transitionOnMount) {
        this.startTransition(!(0, _renderProp.isRenderable)(children), duration);
      } else if ((0, _renderProp.isRenderable)(children)) {
        (0, _Functions.callIfPossible)(onOpenStart);
        (0, _Functions.callIfPossible)(onOpenComplete);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props3 = this.props,
          children = _this$props3.children,
          duration = _this$props3.duration,
          transitionOnUpdate = _this$props3.transitionOnUpdate; // ⚠️ This condition prevents infinite loops! ⚠️

      if (prevProps.children === children) return;

      if ((0, _renderProp.isRenderable)(children)) {
        this.cacheChildren(children);
      }

      if (transitionOnUpdate) {
        if (!(0, _renderProp.isRenderable)(prevProps.children) && (0, _renderProp.isRenderable)(children)) {
          this.startTransition(false, duration);
        } else if ((0, _renderProp.isRenderable)(prevProps.children) && !(0, _renderProp.isRenderable)(children)) {
          this.startTransition(true, duration);
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._isMounted = false;
      cancelAnimationFrame(this._frame);
    }
  }, {
    key: "cacheChildren",
    value: function cacheChildren(children) {
      if (children === this.state.cachedChildren) return;
      this.setState({
        cachedChildren: children
      });
    }
  }, {
    key: "startTransition",
    value: function startTransition(hidden, duration) {
      var _this2 = this;

      var _this$props4 = this.props,
          onOpenStart = _this$props4.onOpenStart,
          onCloseStart = _this$props4.onCloseStart;

      if (hidden) {
        (0, _Functions.callIfPossible)(onCloseStart);
      } else {
        (0, _Functions.callIfPossible)(onOpenStart);
      } // Clear any other pending timers on the component


      cancelAnimationFrame(this._frame);
      clearTimeout(this._timeout); // If duration={0}, skip the CSS transition entirely (#6542)

      if (duration === 0) {
        this.setState({
          hidden: hidden
        });
        this.stopTransition(hidden);
        return;
      } // Edge case: If startTransition() is called again before the setState() callback fires, abort.


      this._t += 1;
      var setStateHandle = this._t;
      this.setState({
        transitioning: true
      }, function () {
        if (setStateHandle !== _this2._t) return; // Normally, two RAFs are the correct amount of time to wait before applying style changes to
        // trigger a transition. However, we need three to allow React changes to flush to the DOM.

        _this2._frame = requestAnimationFrame(function () {
          _this2._frame = requestAnimationFrame(function () {
            _this2._frame = requestAnimationFrame(function () {
              if (!_this2._isMounted) return;

              _this2.setState({
                hidden: hidden,
                closing: hidden,
                opening: !hidden,
                transitionActive: true
              });

              _this2._timeout = setTimeout(_this2.stopTransition, duration);
            });
          });
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props5 = this.props,
          ContextProvider = _this$props5.ContextProvider,
          __onOpenStart = _this$props5.onOpenStart,
          __onOpenComplete = _this$props5.onOpenComplete,
          __onCloseStart = _this$props5.onCloseStart,
          __onCloseComplete = _this$props5.onCloseComplete,
          transitionOnMount = _this$props5.transitionOnMount,
          __transitionOnUpdate = _this$props5.transitionOnUpdate,
          children = _this$props5.children,
          duration = _this$props5.duration,
          Wrapper = _this$props5.Wrapper,
          rest = (0, _objectWithoutProperties2.default)(_this$props5, ["ContextProvider", "onOpenStart", "onOpenComplete", "onCloseStart", "onCloseComplete", "transitionOnMount", "transitionOnUpdate", "children", "duration", "Wrapper"]);
      var _this$state = this.state,
          hidden = _this$state.hidden,
          cachedChildren = _this$state.cachedChildren,
          transitioning = _this$state.transitioning,
          transitionActive = _this$state.transitionActive,
          opening = _this$state.opening,
          closing = _this$state.closing;
      var isInitialTransitionPending = !this._isMounted && transitionOnMount;

      var renderedWrapper = _react.default.createElement(Wrapper, (0, _extends2.default)({}, rest, {
        duration: duration,
        open: !hidden,
        opening: opening,
        closing: closing,
        transitioning: transitioning,
        transitionActive: transitionActive
      }), (0, _renderProp.isRenderable)(children) ? children : cachedChildren);

      return ContextProvider ? _react.default.createElement(ContextProvider, {
        value: getContextValue(transitioning || isInitialTransitionPending)
      }, renderedWrapper) : renderedWrapper;
    }
  }]);
  return TwoWayTransition;
}(_react.default.Component);

var wrapperPropTypes = {
  duration: _propTypes.default.number,
  open: _propTypes.default.bool.isRequired,
  transitioning: _propTypes.default.bool.isRequired,
  transitionActive: _propTypes.default.bool.isRequired,
  closing: _propTypes.default.bool.isRequired,
  opening: _propTypes.default.bool.isRequired
};
TwoWayTransition.propTypes = {
  children: _propTypes.default.node,
  ContextProvider: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object]),
  duration: _propTypes.default.number.isRequired,
  onCloseComplete: _propTypes.default.func,
  onCloseStart: _propTypes.default.func,
  onOpenComplete: _propTypes.default.func,
  onOpenStart: _propTypes.default.func,
  transitionOnMount: _propTypes.default.bool.isRequired,
  transitionOnUpdate: _propTypes.default.bool.isRequired,
  Wrapper: (0, _renderProp.getPropType)({
    propTypes: {
      wrapperPropTypes: wrapperPropTypes
    }
  }).isRequired
};
TwoWayTransition.defaultProps = {
  children: null,
  transitionOnMount: false,
  transitionOnUpdate: true
};
TwoWayTransition.displayName = 'TwoWayTransition';

var PlainWrapper = _styledComponents.default.div.attrs({
  'data-transition-wrapper': true
}).withConfig({
  displayName: "TwoWayTransition__PlainWrapper",
  componentId: "xhcehn-0"
})(_templateObject());

PlainWrapper.displayName = 'TwoWayTransition.PlainWrapper';
TwoWayTransition.PlainWrapper = PlainWrapper;
var _default = TwoWayTransition;
exports.default = _default;
module.exports = exports.default;